package com.bikompanion.domain

enum class BikeVoteFailure {
    InvalidBike,
    Rejected,
}
